<template>
  <div>
    <v-dialog v-model="profileEdit" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <div class="flex flex-row gap-4 items-end pl-0">
          <v-btn
            style="max-width: fit-content;"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Update Profile
          </v-btn>
          <PlaidLink
            :userName="user.emailAddress"
            classNames="v-btn v-btn--contained theme--dark v-size--default primary"
          />
        </div>
      </template>
      <ProfileForm v-on:dialog-close="profileEdit = false"></ProfileForm>
    </v-dialog>
    <accordion class="mb-4" :isOpen="true">
      <template v-slot:title>
        <v-card-title class="flex gap-4 pl-0">
          Contact Information
          <v-spacer></v-spacer>
        </v-card-title>
      </template>
      <template v-slot:content>
        <v-card height="100%">
          <v-img
            max-height="50"
            max-width="50"
            :src="user.avatarImage"
            class="p-4"
          ></v-img>
          <v-card-subtitle v-if="!profile.complete" class="red--text text-bold">
            You have not completed your profile! You will not be able to make
            any share purchases until your profile is complete.
          </v-card-subtitle>

          <v-card-text>
            <v-list-item v-if="user.firstName && user.lastName">
              <v-list-item-content>
                <v-list-item-title>Name</v-list-item-title>
                <v-list-item-subtitle
                  >{{ user.firstName }}
                  {{ user.lastName }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Email Address
                  <v-icon small color="green">
                    mdi-check-bold
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  user.emailAddress
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="profile.phoneNumber">
              <v-list-item-content>
                <v-list-item-title>
                  Phone Number
                  <v-icon small color="green">
                    mdi-check-bold
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  profile.phoneNumber
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Physical Address
                  <v-icon v-if="profile.addressLine1" small color="green">
                    mdi-check-bold
                  </v-icon>
                  <v-icon v-else small color="error">
                    mdi-alert-circle
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle v-if="profile.addressLine1">
                  <div>{{ profile.addressLine1 }}</div>
                  <div v-if="profile.addressLine2">
                    {{ profile.addressLine2 }}
                  </div>
                  <div>
                    {{ profile.addressCity }}, {{ profile.addressState }}
                    {{ profile.addressPostalCode }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Identity Information
                  <v-icon v-if="profile.complete" small color="green">
                    mdi-check-bold
                  </v-icon>
                  <v-icon v-else small color="error">
                    mdi-alert-circle
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle v-if="profile.complete"
                  >●●● - ●● - ●●●●</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </template>
    </accordion>

    <!-- Bank info -->
    <accordion class="mb-4" :isOpen="true">
      <template v-slot:title>
        <v-card-title class="flex gap-4 pl-0">
          Payment Information
          <v-spacer></v-spacer>
        </v-card-title>
      </template>
      <template v-slot:content>
        <v-card height="100%">
          <v-card-text>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Banks
                </v-list-item-title>
                <div
                  v-for="item in userIntegrations"
                  :key="item.id"
                  class="text-base !pl-0"
                >
                  <v-list-item-subtitle v-if="item.ach">
                    {{ item.name }}
                  </v-list-item-subtitle>
                </div>
                <v-list-item-title class="pt-4">
                  Credit Cards
                </v-list-item-title>
                <div
                  v-for="item in userIntegrations"
                  :key="item.id"
                  class="text-base"
                >
                  <v-list-item-subtitle v-if="!item.ach">
                    {{ item.name }}
                  </v-list-item-subtitle>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </template>
    </accordion>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProfileForm from "./ProfileForm.vue";
import PlaidLink from "./PlaidLink.vue";
import Accordion from "../Accordion.vue";

export default {
  name: "AccountDetails",

  components: {
    ProfileForm,
    PlaidLink,
    Accordion,
  },
  data: () => ({
    profileEdit: false,
  }),

  computed: {
    ...mapGetters(["user", "profile", "userIntegrations"]),
  },
  methods: {
    ...mapActions(["getUserIntegrations"]),
  },
  created() {
    this.getUserIntegrations();
  },
};
</script>
